@if (total) {
  <div class="pagination-counter">
    <ng-container *ngTemplateOutlet="activeTpl"></ng-container>
  </div>
}

<ng-template #fullTextTpl>
  <strong>{{ start }} - {{ end }}</strong> {{ 'rtu.common.of' | translate }}
  <strong>{{ total }}</strong
  >&nbsp;<span class="pagination-counter-label">{{ label }}</span>
</ng-template>

<ng-template #shortenedTpl>
  <div class="partial-text" [rtTooltip]="tooltipMessage">
    <strong>{{ start }} - {{ end }}</strong
    >...
  </div>
</ng-template>
